// import { observer } from 'mobx-react-lite';
// import React, { useCallback } from 'react';
// import { FormattedMessage, useIntl } from 'react-intl';

// import useContentPage from '../../hooks/useContentPage';

// import { useApi } from '../../components/ApiProvider';
// import ContentPageWrapper from '../../components/ContentPageWrapper';
// import Title from '../../components/Title';
// import Layout from '../../components/Layout';
// import SEO from '../../components/SEO';

// const FaqPage = ({ uri }) => {
//   const intl = useIntl();
//   const apiClient = useApi();

//   const { markup } = useContentPage({
//     page: 'faq',
//     onFetch: useCallback(
//       async language => {
//         let result = '';

//         try {
//           const {
//             data: { response }
//           } = await apiClient.sendRequest('get', '/page/content', {
//             query: {
//               page: 'faq_r2d2',
//               language
//             }
//           });
//           result = response;
//         } catch (err) {
//           // Do nothing if request fails
//         }

//         const {
//           data: { response }
//         } = await apiClient.sendRequest('get', '/page/content', {
//           query: {
//             page: 'faq',
//             language
//           }
//         });

//         result = `${result}${response}`;

//         return result;
//       },
//       [apiClient]
//     )
//   });

//   return (
//     <Layout alwaysRaisedHeader uri={uri}>
//       <SEO
//         title={intl.formatMessage({
//           id: 'meta.title.faq',
//           defaultMessage: 'Frequently Asked Questions'
//         })}
//         description={intl.formatMessage({
//           id: 'meta.description.faq',
//           defaultMessage:
//             "STK Workshop Customer Support - Find out more about the Build Your Own R2-D2 Subscription, Shipment, Cancellation, how to contact us. We're here to help you with your modelling experience."
//         })}
//       />
//       <ContentPageWrapper>
//         <Title>
//           <FormattedMessage defaultMessage="FAQ" />
//         </Title>
//         <div dangerouslySetInnerHTML={{ __html: markup }} />
//       </ContentPageWrapper>
//     </Layout>
//   );
// };

// export default observer(FaqPage);

import React from 'react';
import Redirect from '../../components/Redirect';

const IndexPage = () => {
  return <Redirect to="https://www.stk-workshop.com/" includeQuery />;
  // return <Redirect to="/r2d2" includeQuery />;
};

export default IndexPage;
